<template>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{new Date().getFullYear()}} © Semantic Click.
            </div>
           
        </div>
    </div>
</footer>
</template>
